import { EConclusion } from '../types/calculate';

export const CONCLUSION_TYPE_TO_ANALYTICS_LABEL_MAP: { [key in EConclusion]: string } = {
  [EConclusion.MortgageProfitable]: 'result_popup_mort',
  [EConclusion.DepositProfitable]: 'result_popup_save',
  [EConclusion.MortgageNoSense]: 'result_popup_wait',
  [EConclusion.NotMatter]: 'result_popup_indif',
  [EConclusion.EmptyInput]: 'result_popup_empty',
  [EConclusion.EnoughMoney]: 'result_popup_buy',
  [EConclusion.NotEnoughMoney]: 'result_popup_hopeless',
  [EConclusion.DepositOnly]: 'result_popup_nomort',
  [EConclusion.InadequateMortgagePayment]: 'result_popup_nomort',
};
